import { createStyles, makeStyles, Theme } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {
  FONTS,
  OP_SYMBLS,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
} from "../../constants";
import { addAlpha, convertToNumber } from "../../helpers/DataHelpers";
import { formatNumber } from "../../helpers/FormatNumber";
import { cleanDataFilterType, stateType, stateTypeF } from "../../state";
import { trimString } from "../Common/helpers";
import { makeHistData } from "../Common/makeHistData";
import { applyFiltersToData } from "./filters";

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    closeIcon: { "&:hover": { transform: "scale(1.1)" } },
  });
});

type selectedFilterIconType = {
  state: stateTypeF;
  filter: cleanDataFilterType;
};

export function SelectedFilterIcons({ state }: stateType) {
  let filters = state.saveState.cleanData.cleanDataFilters.map((filter) => (
    <SelectedFilter state={state} filter={filter}></SelectedFilter>
  ));

  const rowSize = 4;
  let rows = [];
  for (let i = 0; i < filters.length; i += rowSize) {
    const chunk = filters.slice(i, i + rowSize);
    rows.push(chunk);
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        marginLeft: "-10px",
        marginBottom: "-10px",
        marginTop: "20px",
        width: "100%",
      }}
    >
      {rows.map((filters) => (
        <div style={{ display: "flex", flexDirection: "row" }}>
          {filters.map((filter) => filter)}
        </div>
      ))}
    </div>
  );
}

export function SelectedFilter({ state, filter }: selectedFilterIconType) {
  let colName = filter.column;
  let operation = filter.operation;
  let value = formatNumber(convertToNumber(filter.value));
  let replace_with = formatNumber(convertToNumber(filter.replace_with));
  let drop_row = filter.drop_row;
  let txt = undefined;

  const classes = useStyles();

  if (drop_row) {
    txt = `Drop rows.`;
  } else {
    txt = `Replace with '${trimString(replace_with, 21)}'`;
  }

  function handleDelete() {
    let filters = [...state.saveState.cleanData.cleanDataFilters];
    let newFilters = [];
    for (let f of filters) {
      if (f.index === filter.index) {
        continue;
      }
      f.index = newFilters.length;
      newFilters.push(f);
    }

    if (
      filter.column === state.saveState.cleanData.cleanHistSelected ||
      filter.drop_row
    ) {
      let col = state.saveState.dataset.getColumn(filter.column);

      // Get filtered data
      let { data } = applyFiltersToData(
        state.saveState.dataset.data,
        state.saveState.cleanData.cleanHistSelected,
        newFilters,
        state.saveState.cleanData.cleanRowsSelected,
        new Set()
      );

      let histData = makeHistData(
        data,
        col.columnType,
        state.saveState.cleanData.cleanRowsSelected,
        col.colStats.median
      );

      state.saveState.cleanData.cleanHistData = histData;
      state.setSaveState(state.saveState);
    }

    state.saveState.cleanData.cleanDataFilters = newFilters;
    state.setSaveState(state.saveState);
  }

  return (
    <div
      style={{
        fontFamily: FONTS,
        backgroundColor:
          state.saveState.cleanData.cleanHistSelected === colName
            ? addAlpha(SECONDARY_COLOR, 0.4)
            : addAlpha(PRIMARY_COLOR, 0.1),
        borderColor: "#0583D2",
        borderRadius: "10px",
        border: "solid",
        borderWidth: "2px",
        display: "flex",
        marginLeft: "10px",
        marginBottom: "10px",
      }}
    >
      <div style={{ margin: "8px", marginTop: "8px" }}>
        <div style={{ fontWeight: "bold", fontSize: "13px" }}>
          {`${trimString(colName, 21)} ${OP_SYMBLS[operation]} ${trimString(
            value,
            21
          )} `}
        </div>
        <div style={{ fontFamily: FONTS, fontSize: "13px" }}>{txt}</div>
      </div>
      <div
        style={{
          marginTop: "0px",
          marginRight: "1px",
          marginLeft: "auto",
          cursor: "pointer",
        }}
        onClick={handleDelete}
      >
        <CloseIcon className={classes.closeIcon}></CloseIcon>
      </div>
    </div>
  );
}
